import { render } from "./PromoPage.vue?vue&type=template&id=f6473072"
import script from "./PromoPage.vue?vue&type=script&lang=js"
export * from "./PromoPage.vue?vue&type=script&lang=js"

import "./PromoPage.vue?vue&type=style&index=0&id=f6473072&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__